import { cEl } from '../../../util';

function ImageMask({ src, name, imgStyle }) {
    const img = cEl('img');
    img.classList.add('carousel-img');
    img.src = src;
    img.alt = name;

    for (const prop in imgStyle) {
        img.style[prop] = imgStyle[prop];
    }

    return img;
}

export default ImageMask;
